export const DOMAIN_URL=process.env.REACT_APP_API_URL;
export const API_VERSION=process.env.REACT_APP_API_VERSION;
export const BASE_URL=`${DOMAIN_URL}${API_VERSION}`;